/** @format */

import intl from 'react-intl-universal';
import download from 'downloadjs';
import mime from 'mime-types';
import userRolesConfig from './userRolesConfig';
import allFalse from './allFalse';
import throttle from './throttle';
import capitalize from './capitalize';
import getKeyOfValue from './getKeyOfValue';
import transformFormValues from './transformFormValues';
import getMessageId from './getMessageId';
import cleanArray from './cleanArray';
import urlParamsMapper from './urlParamsMapper';
import { deviceDetect } from 'react-device-detect';
import { persistor } from 'src/store/configureStore';

function updateBodyClass(name) {
  const bodyClass = name.replace(/[/]/gi, '').toLowerCase();
  document.body.classList.toggle(bodyClass);
}
function getDeviceDetails() {
  return deviceDetect();
}

function getAPIUrls(host = '', paths = {}, overrides = {}) {
  return Object.entries(paths).reduce((acc, [key, val]) => {
    return { ...acc, [key]: overrides[key] ? overrides[key] : host + val };
  }, {});
}

function createTableData(type, config) {
  if (config.columns === undefined || config.rows === undefined) {
    throw Error(intl.get('controls.table.createDataError'));
  }

  /* if no visible order is provided then assume all values in `key` will be visible unless overriden from options */
  const visibleKeys = config.visible || config.columns;
  const visibleCols = visibleKeys.reduce((acc, next) => {
    acc[next] = true;
    return acc;
  }, {});

  const cols = config.columns.map(col => ({
    id: col,
    displayText: intl.get(`${type}.headers.${col}`),
    sortable: type !== 'AuditTable' ? true : false,
    visible: visibleCols[col] || false,
    ...(config.options && config.options[col] ? config.options[col] : {}),
  }));
  if (type !== 'AuditTable') cols[0].stickyLeft = true;

  const rows = config.rows.map(row => {
    return cols.map(column => {
      return row[column.id] !== undefined && row[column.id] !== null ? row[column.id].toString() : '';
    });
  });

  return {
    columns: cols,
    rows,
  };
}

function createRowMap(columns, row) {
  const rowMap = columns.reduce((acc, next, index) => {
    acc[next.id] = row[index].value;
    return acc;
  }, {});

  return rowMap;
}

function checkFields(source, fields) {
  const isFieldsFilled = fields.reduce((acc, next) => {
    if (source[next] === '' || source[next] === undefined || source[next] === null || source[next] === -1) {
      acc = false;
    }
    return acc;
  }, true);

  return isFieldsFilled;
}

function selectItemInArrays(index, data) {
  let flattened;
  if (Array.isArray(data)) {
    flattened = data;
    return flattened[index];
  }
}

function saveAPIFile(attachmentData, fileName) {
  if (fileName) {
    fileName = fileName.split('\\').pop();
  }
  download(atob(attachmentData), fileName, mime.lookup(fileName));
}

function transformToVals(data) {
  return {
    firstName: data.name,
    lastName: '',
    engagement: data.company,
    emailId: data.email,
  };
}

function transformCaseVals(data) {
  return {
    firstName: data.firstName,
    lastName: data.lastName,
    engagement: data.engagement,
    caseId: data.caseId,
    caseManagerId: data.caseManagerId,
  };
}

function getToProperty(arr) {
  if (arr.length > 1) {
    let ref = arr.map((each, i) => {
      // limit returned results to only first 3
      if (i < 4) return each.name + ', ' + each.company;
      return false;
    });
    return ref.join('; ');
  } else {
    return arr[0] && arr[0].name + ', ' + arr[0].company;
  }
}

/**
 *
 * @param {Object} formData
 * @param {Object} page
 */
const removeReadOnlyFromPayload = (formData, page) => {
  const readOnly = ['WPVerticalTable', 'WPHorizontalTable'];

  const { pageElements } = page;
  const controlsReadOnly = [];
  pageElements.map(control => {
    if (readOnly.includes(control.controlTypeName)) {
      controlsReadOnly.push(control.elementName);
    }
  });

  if (controlsReadOnly && controlsReadOnly.length) {
    const tableFormData = formData.tables;
    let newTables = {};
    for (const key in tableFormData) {
      if (Object.hasOwnProperty.call(tableFormData, key)) {
        const element = tableFormData[key];
        controlsReadOnly.includes(key);
        if (!controlsReadOnly.includes(key)) {
          newTables[key] = element;
        }
      }
    }
    return {
      ...formData,
      tables: newTables,
    };
  }

  return formData;
};

function isDeleteProfile() {
  let userRoles = JSON.parse(sessionStorage.getItem('userInfo')).permissions;
  let roleName = { roleName: 'DELETE_PROFILE' };
  const deleteUserRole = userRoles.some(role => role.roleName === roleName.roleName);
  return deleteUserRole;
}

function isEYAdministrator() {
  let userRoles = JSON.parse(sessionStorage.getItem('userInfo')).permissions;
  let roleName = { roleName: 'EY Administrator' };
  const adminUserRole = userRoles.some(role => role.roleName === roleName.roleName);
  return adminUserRole;
}

function isEYPro() {
  let userRoles = JSON.parse(sessionStorage.getItem('userInfo')).permissions;
  let roleName = { roleName: 'EY Pro' };
  const adminUserRole = userRoles.some(role => role.roleName === roleName.roleName);
  return adminUserRole;
}

function isTaxChatSuperAdmin() {
  let userRoles = JSON.parse(sessionStorage.getItem('userInfo')).permissions;
  let roleName = { roleName: 'TAXCHAT-SUPER-ADMIN'};
  const adminUserRole = userRoles.some(role => role.roleName === roleName.roleName);
  return adminUserRole;
}

//clear Presist:root from localstorage while logout
const clearPresistfromLocalStorge = async () => {
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
};

//Resume Presist:root from localstorage while login
const enablePresist = async () => {
  return persistor.persist();
};

// Clear cookies from the Browser to avoid cache issue
const clearCookieFromBrowserStorage = () => {
  document.cookie.split(";").forEach((c) => {
    if(c.indexOf('ai_user') > -1 || c.indexOf('ai_session') > -1){
      return
    }
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;");
  });
}

export {
  allFalse,
  capitalize,
  checkFields,
  cleanArray,
  createRowMap,
  createTableData,
  getAPIUrls,
  getDeviceDetails,
  getKeyOfValue,
  getMessageId,
  getToProperty,
  removeReadOnlyFromPayload,
  saveAPIFile,
  selectItemInArrays,
  throttle,
  transformCaseVals,
  transformFormValues,
  transformToVals,
  updateBodyClass,
  urlParamsMapper,
  userRolesConfig,
  isDeleteProfile,
  clearPresistfromLocalStorge,
  enablePresist,
  clearCookieFromBrowserStorage,
  isEYAdministrator,
  isEYPro,
  isTaxChatSuperAdmin
};



// WEBPACK FOOTER //
// ./src/helpers/index.js